export const cortesRoles = {
  Chief: 'Chief',
  Admin: 'Admin',
  Viewer: 'Viewer',
  PlasticChief: 'PlasticChief',
  PlasticEngineer: 'PlasticEngineer',
  PlasticInspectionTrimming: 'PlasticInspectionTrimming',
  PlasticLeaderTrimming: 'PlasticLeaderTrimming',
  PlasticViewer: 'PlasticViewer',
  PlasticLabelOperator: 'PlasticLabelOperator',
  LabelOperator: 'LabelOperator',
};
const accesToAllActions = [
  cortesRoles.Admin,
  cortesRoles.Chief,
  cortesRoles.PlasticChief,
];
const accesToAllViews = [
  cortesRoles.Admin,
  cortesRoles.Chief,
  cortesRoles.PlasticChief,
  cortesRoles.PlasticViewer,
  cortesRoles.Viewer,
];

export const cortesViewRoles = {
  verDepartment: [
    ...accesToAllViews,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticInspectionTrimming,
    cortesRoles.PlasticLeaderTrimming,
  ],
  verInspection: [
    ...accesToAllViews,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticInspectionTrimming,
    cortesRoles.PlasticLeaderTrimming,
  ],
  verValidacion: [
    ...accesToAllViews,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticInspectionTrimming,
    cortesRoles.PlasticLeaderTrimming,
  ],
  verCortes: [
    ...accesToAllViews,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticInspectionTrimming,
    cortesRoles.PlasticLeaderTrimming,
  ],
  verEtiquetas: [
    cortesRoles.Chief,
    cortesRoles.Admin,
    cortesRoles.PlasticLeaderTrimming,
    cortesRoles.LabelOperator,
    cortesRoles.PlasticLabelOperator,
  ],
};

export const cortesActionsRoles = {
  Balancear: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticLeaderTrimming,
  ],
  EnviaraInspeccion: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticLeaderTrimming,
  ],
  TranformarNumerosDePartes: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticLeaderTrimming,
  ],
  EnviarFueraDeTiempo: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticLeaderTrimming,
  ],
  TranformarFueraDeTiempo: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticLeaderTrimming,
  ],
  InspeccionarSimple: [
    ...accesToAllActions,
    cortesRoles.PlasticInspectionTrimming,
  ],
  Verficar: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    ,
    cortesRoles.PlasticInspectionTrimming,
    cortesRoles.PlasticLeaderTrimming,
  ],
  Enviarvalidacion: [
    ...accesToAllActions,
    cortesRoles.PlasticEngineer,
    cortesRoles.PlasticLeaderTrimming,
  ],
};
